import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from '../firebase';
import {  doc, getDoc,} from 'firebase/firestore';
import axios from 'axios';
 import { useNavigate } from 'react-router-dom';


const RaiseTicketModal = ({ isOpen, onClose, orderId }) => {
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({
        category: '',
        orderIdOrAwb: orderId || '',    
        comment: '',
        Storeorder_id: '', 
        attachedFile: null,
        attachedFiles: [], // Change to array for multiple files
        expectedResolution: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [brandName, setBrandName] = useState('');
    const [orderSuggestions, setOrderSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [isLoadingOrders, setIsLoadingOrders] = useState(false);
 const API_BASE_URL = 'https://ufb-1.onrender.com/ticket';

    const user = auth.currentUser;

    useEffect(() => {
        const fetchBrandName = async () => {
            if (user) {
                try {
                    const userRef = doc(db, 'users', user.uid); // 👈 adjust collection name if different
                    const userSnap = await getDoc(userRef);
                    if (userSnap.exists()) {
                        setBrandName(userSnap.data().brandName || '');
                    }
                } catch (err) {
                    console.error('Error fetching brand name:', err);
                }
            }
        };
        fetchBrandName();
    }, [user, db]);

    const categories = [
        'Printing Problem',
        'Damaged / Wrong Product',
        'Shipping & Delivery',
        'Technical Problem',
        'Payment Queries',
        'COD Remittance',
        'Other'
    ];

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         if (file.size > 10 * 1024 * 1024) {
    //             setErrors(prev => ({
    //                 ...prev,
    //                 attachedFile: 'File size must be less than 10MB'
    //             }));
    //             return;
    //         }
    //         const allowedTypes = [
    //             'image/jpeg',
    //             'image/png',
    //             'image/gif',
    //             'application/pdf',
    //             'text/plain',
    //             'application/msword',
    //             'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    //         ];
    //         if (!allowedTypes.includes(file.type)) {
    //             setErrors(prev => ({
    //                 ...prev,
    //                 attachedFile: 'File type not supported. Please upload JPEG, PNG, GIF, PDF, TXT, or DOC files.'
    //             }));
    //             return;
    //         }
    //         setFormData(prev => ({
    //             ...prev,
    //             attachedFile: file
    //         }));
    //         if (errors.attachedFile) {
    //             setErrors(prev => ({
    //                 ...prev,
    //                 attachedFile: ''
    //             }));
    //         }
    //     }
    // };


const handleFileChange = (e) => {
    console.log('=== File Change Event Triggered ===');
    const newFiles = Array.from(e.target.files);
    console.log('New files selected:', newFiles.length);
    console.log('Current attachedFiles:', formData.attachedFiles.length);
    
    if (newFiles.length === 0) return;
    
    // Combine existing files with new files
    const allFiles = [...formData.attachedFiles, ...newFiles];
    const maxFiles = 5;
    const maxSizePerFile = 10 * 1024 * 1024;
    
    if (allFiles.length > maxFiles) {
        setErrors(prev => ({
            ...prev,
            attachedFiles: `Maximum ${maxFiles} files allowed. You currently have ${formData.attachedFiles.length} files.`
        }));
        // Clear the file input
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        return;
    }
    
    const validFiles = [];
    let hasError = false;
    
    // Validate only the new files
    for (const file of newFiles) {
        if (file.size > maxSizePerFile) {
            setErrors(prev => ({
                ...prev,
                attachedFiles: `File "${file.name}" is too large. Max size is 10MB per file.`
            }));
            hasError = true;
            break;
        }
        
        const allowedTypes = [
            'image/jpeg', 'image/png', 'image/gif', 'application/pdf',
            'text/plain', 'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'video/mp4', 'video/webm', 'audio/mp3', 'audio/wav'
        ];
        
        if (!allowedTypes.includes(file.type)) {
            setErrors(prev => ({
                ...prev,
                attachedFiles: `File type not supported for "${file.name}"`
            }));
            hasError = true;
            break;
        }
        
        validFiles.push(file);
    }
    
    if (!hasError) {
        // Add new valid files to existing files
        setFormData(prev => ({
            ...prev,
            attachedFiles: [...prev.attachedFiles, ...validFiles]
        }));
        
        if (errors.attachedFiles) {
            setErrors(prev => ({
                ...prev,
                attachedFiles: ''
            }));
        }
    }
    
    // Clear the file input so user can select more files
    if (fileInputRef.current) {
        fileInputRef.current.value = '';
    }
    
    console.log('=== End File Change Event ===');
};


const removeFile = (indexToRemove) => {
    setFormData(prev => ({
        ...prev,
        attachedFiles: prev.attachedFiles.filter((_, index) => index !== indexToRemove)
    }));
};

    // const validateForm = () => {
    //     const newErrors = {};
    //     if (!formData.category.trim()) newErrors.category = 'Category is required';
    //     if (!formData.orderIdOrAwb.trim()) newErrors.orderIdOrAwb = 'Order ID or AWB number is required';
    //     if (!formData.comment.trim()) {
    //         newErrors.comment = 'Comment is required';
    //     } else if (formData.comment.length > 500) {
    //         newErrors.comment = 'Comment must be 500 characters or less';
    //     }
    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

const validateForm = () => {
    const newErrors = {};
    if (!formData.category.trim()) newErrors.category = 'Category is required';
    
    // Make order ID optional for Technical Problem and Payment Queries
    const optionalOrderCategories = ['Technical Problem', 'Payment Queries'];
    if (!optionalOrderCategories.includes(formData.category) && !formData.orderIdOrAwb.trim()) {
        newErrors.orderIdOrAwb = 'Order ID or AWB number is required';
    }
    
    if (!formData.comment.trim()) {
        newErrors.comment = 'Comment is required';
    } else if (formData.comment.length > 500) {
        newErrors.comment = 'Comment must be 500 characters or less';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};


    const fetchOrderSuggestions = async (searchTerm) => {
    if (!user || !searchTerm || searchTerm.length < 2) {
        setOrderSuggestions([]);
        setShowSuggestions(false);
        return;
    }

    try {
        setIsLoadingOrders(true);
        const response = await axios.get(`${API_BASE_URL}/api/user-orders/${user.uid}`, {
            params: { search: searchTerm }
        });
        
        if (response.data.success) {
            setOrderSuggestions(response.data.data);
            setShowSuggestions(true);
        }
    } catch (error) {
        console.error('Error fetching order suggestions:', error);
        setOrderSuggestions([]);
    } finally {
        setIsLoadingOrders(false);
    }
};


const handleOrderIdChange = (value) => {
    handleInputChange('orderIdOrAwb', value);
    fetchOrderSuggestions(value);
};

const selectOrderSuggestion = (order) => {
    setFormData(prev => ({
        ...prev,
        orderIdOrAwb: order.orderId,
        Storeorder_id: order.Storeorder_id || '' // Add store order ID
    }));
    setShowSuggestions(false);
    setOrderSuggestions([]);
};

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        if (!user) {
            alert('You must be logged in to raise a ticket');
            return;
        }
        try {
            setIsSubmitting(true);
            const ticketId = `TKT${Date.now()}`;

            const apiFormData = new FormData();
            apiFormData.append('ticketId', ticketId);
            apiFormData.append('category', formData.category);
            apiFormData.append('orderIdOrAwb', formData.orderIdOrAwb);
            apiFormData.append('Storeorder_id', formData.Storeorder_id);
            apiFormData.append('comment', formData.comment);
            apiFormData.append('expectedResolution', formData.expectedResolution);
            apiFormData.append('brandName', brandName); // ✅ fetched from Firestore
            apiFormData.append('user_uid', user.uid);
            apiFormData.append('userEmail', user.email || '');

          if (formData.attachedFiles && formData.attachedFiles.length > 0) {
            formData.attachedFiles.forEach((file, index) => {
                apiFormData.append(`attachedFiles`, file);
            });
        }

            const response = await axios.post(`${API_BASE_URL}/api/raise-ticket`, apiFormData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.data.success) {
                alert(`Ticket raised successfully! Ticket ID: ${response.data.data.ticketId}`);
                setFormData({
                    category: '',
                    orderIdOrAwb: orderId || '',
                    comment: '',
                    attachedFiles: [],
                    expectedResolution: '',
                    Storeorder_id: ''
                });
           if (fileInputRef.current) {
    fileInputRef.current.value = '';
}
onClose();
navigate('/tickets');
            } else {
                alert(response.data.message || 'Failed to raise ticket. Please try again.');
            }
        } catch (error) {
            console.error('Error raising ticket:', error);
            const errorMessage = error.response?.data?.message || 'Failed to raise ticket. Please try again.';
            alert(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (!isSubmitting) {
                  setFormData({
            category: '',
            orderIdOrAwb: orderId || '',
            comment: '',
            attachedFiles: [],  // Correct field name
            expectedResolution: '',
            Storeorder_id: ''
        });
            setErrors({});
            if (fileInputRef.current) {
    fileInputRef.current.value = '';
}
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto mx-4">
                <div className="flex items-center justify-between p-6 border-b">
                    <h2 className="text-xl font-semibold text-gray-900">Raise Ticket</h2>
                    <button 
                        className="text-gray-400 hover:text-gray-600 text-2xl w-8 h-8 flex items-center justify-center disabled:opacity-50" 
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>
                
                <form onSubmit={handleSubmit} className="p-6">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Select Category <span className="text-red-500">*</span>
                        </label>
                        <select
                            value={formData.category}
                            onChange={(e) => handleInputChange('category', e.target.value)}
                            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 ${errors.category ? 'border-red-500' : 'border-gray-300'}`}
                            disabled={isSubmitting}
                        >
                            <option value="">Select a category</option>
                            {categories.map(category => (
                                <option key={category} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                        {errors.category && (
                            <span className="text-red-500 text-sm mt-1 block">{errors.category}</span>
                        )}
                    </div>

                    {/* <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Order ID or AWB Number <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            value={formData.orderIdOrAwb}
                            onChange={(e) => handleInputChange('orderIdOrAwb', e.target.value)}
                            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 ${errors.orderIdOrAwb ? 'border-red-500' : 'border-gray-300'}`}
                            placeholder="Enter order ID or AWB number"
                            disabled={isSubmitting}
                        />
                        {errors.orderIdOrAwb && (
                            <span className="text-red-500 text-sm mt-1 block">{errors.orderIdOrAwb}</span>
                        )}
                    </div> */}

<div className="mb-4 relative">
    <label className="block text-sm font-medium text-gray-700 mb-2">
        Order ID or AWB Number 
        {!['Technical Problem', 'Payment Queries'].includes(formData.category) && 
            <span className="text-red-500">*</span>
        }
        {['Technical Problem', 'Payment Queries'].includes(formData.category) && 
            <span className="text-gray-500 text-sm ml-1">(Optional)</span>
        }
    </label>
    <input
        type="text"
        value={formData.orderIdOrAwb}
        onChange={(e) => handleOrderIdChange(e.target.value)}
        onFocus={() => {
            if (formData.orderIdOrAwb && orderSuggestions.length > 0) {
                setShowSuggestions(true);
            }
        }}
        onBlur={() => {
            // Delay hiding suggestions to allow click
            setTimeout(() => setShowSuggestions(false), 200);
        }}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 ${errors.orderIdOrAwb ? 'border-red-500' : 'border-gray-300'}`}
        placeholder="Enter order ID or AWB number"
        disabled={isSubmitting}
    />
    
    {/* Order Suggestions Dropdown */}
    {showSuggestions && orderSuggestions.length > 0 && (
        <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto mt-1">
            {orderSuggestions.map((order, index) => (
                <div
                    key={order.orderId}
                    onClick={() => selectOrderSuggestion(order)}
                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                >
                    <div className="text-sm font-medium text-gray-900">{order.orderId}</div>
                    {order.Storeorder_id && (
                        <div className="text-xs text-gray-500">Store ID: {order.Storeorder_id}</div>
                    )}
                    {order.customerName && (
                        <div className="text-xs text-gray-500">{order.customerName}</div>
                    )}
                </div>
            ))}
        </div>
    )}
    
    {isLoadingOrders && (
        <div className="absolute right-3 top-10 text-gray-400">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-blue-600"></div>
        </div>
    )}
    
    {errors.orderIdOrAwb && (
        <span className="text-red-500 text-sm mt-1 block">{errors.orderIdOrAwb}</span>
    )}
</div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Comment <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            value={formData.comment}
                            onChange={(e) => handleInputChange('comment', e.target.value)}
                            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 resize-vertical ${errors.comment ? 'border-red-500' : 'border-gray-300'}`}
                            placeholder="Describe your issue in detail..."
                            rows={4}
                            maxLength={500}
                            disabled={isSubmitting}
                        />
                        <div className="text-sm text-gray-500 mt-1">
                            {formData.comment.length}/500 characters
                        </div>
                        {errors.comment && (
                            <span className="text-red-500 text-sm mt-1 block">{errors.comment}</span>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Expected Resolution</label>
                        <textarea
                            value={formData.expectedResolution}
                            onChange={(e) => handleInputChange('expectedResolution', e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 resize-vertical"
                            placeholder="What resolution are you expecting?"
                            rows={2}
                            disabled={isSubmitting}
                        />
                    </div>

                    {/* <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Attach File</label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 file:mr-3 file:py-1 file:px-3 file:border-0 file:rounded file:bg-gray-50 file:text-sm file:font-medium hover:file:bg-gray-100"
                            accept=".jpg,.jpeg,.png,.gif,.pdf,.txt,.doc,.docx,.mp4,.mp3"
                            disabled={isSubmitting}
                        />
                        <div className="text-xs text-gray-500 mt-1">
                            Supported formats: JPEG, PNG, GIF, PDF, TXT, DOC, DOCX, MP4, MP3 (Max: 10MB)
                        </div>
                        {formData.attachedFile && (
                            <div className="text-sm text-green-600 mt-1">
                                Selected: {formData.attachedFile.name}
                            </div>
                        )}
                        {errors.attachedFile && (
                            <span className="text-red-500 text-sm mt-1 block">{errors.attachedFile}</span>
                        )}
                    </div> */}


                    <div className="mb-6">
    <label className="block text-sm font-medium text-gray-700 mb-2">Attach Files</label>
<input
    ref={fileInputRef}
    type="file"
    onChange={handleFileChange}
    multiple
    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 file:mr-3 file:py-1 file:px-3 file:border-0 file:rounded file:bg-gray-50 file:text-sm file:font-medium hover:file:bg-gray-100"
    accept=".jpg,.jpeg,.png,.gif,.pdf,.txt,.doc,.docx,.mp4,.webm,.mp3,.wav"
    disabled={isSubmitting}
/>

    <div className="text-xs text-gray-500 mt-1">
        Max 5 files. Supported: JPEG, PNG, GIF, PDF, TXT, DOC, DOCX, MP4, WebM, MP3, WAV (Max: 10MB each)
    </div>
    
    {/* Display selected files */}
{/* Display selected files */}
{formData.attachedFiles && formData.attachedFiles.length > 0 && (
    <div className="mt-3 space-y-2">
        <p className="text-sm font-medium text-gray-700">
            Selected Files ({formData.attachedFiles.length}):
        </p>
        {formData.attachedFiles.map((file, index) => (
            <div key={`${file.name}-${index}`} className="flex items-center justify-between p-2 bg-gray-50 rounded border">
                <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600">📎</span>
                    <span className="text-sm text-gray-900">{file.name}</span>
                    <span className="text-xs text-gray-500">
                        ({(file.size / 1024 / 1024).toFixed(2)} MB)
                    </span>
                </div>
                <button
                    type="button"
                    onClick={() => removeFile(index)}
                    className="text-red-500 hover:text-red-700 text-sm"
                    disabled={isSubmitting}
                >
                    Remove
                </button>
            </div>
        ))}
    </div>
)}
    
    {errors.attachedFiles && (
        <span className="text-red-500 text-sm mt-1 block">{errors.attachedFiles}</span>
    )}
</div>

                    <div className="flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit Ticket'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RaiseTicketModal;
